import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 59,
    seconds: 52
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className={`flex items-center justify-center gap-2 ${className}`} data-id="element-67">
      <div className="flex flex-col items-center" data-id="element-68">
        <div className="bg-bg-input border border-border-subtle rounded-lg px-4 py-3 min-w-[70px] text-center" data-id="element-69">
          <span className="text-red-countdown text-4xl md:text-5xl font-bold font-mono" data-id="element-70">
            {String(time.hours).padStart(2, '0')}
          </span>
        </div>
        <span className="text-text-muted text-xs mt-2 uppercase tracking-widest" data-id="element-71">
          hs
        </span>
      </div>
      <span className="text-red-countdown text-3xl font-bold mb-6" data-id="element-72">:</span>
      <div className="flex flex-col items-center" data-id="element-73">
        <div className="bg-bg-input border border-border-subtle rounded-lg px-4 py-3 min-w-[70px] text-center" data-id="element-74">
          <span className="text-red-countdown text-4xl md:text-5xl font-bold font-mono" data-id="element-75">
            {String(time.minutes).padStart(2, '0')}
          </span>
        </div>
        <span className="text-text-muted text-xs mt-2 uppercase tracking-widest" data-id="element-76">
          min
        </span>
      </div>
      <span className="text-red-countdown text-3xl font-bold mb-6" data-id="element-77">:</span>
      <div className="flex flex-col items-center" data-id="element-78">
        <div className="bg-bg-input border border-border-subtle rounded-lg px-4 py-3 min-w-[70px] text-center" data-id="element-79">
          <span className="text-red-countdown text-4xl md:text-5xl font-bold font-mono" data-id="element-80">
            {String(time.seconds).padStart(2, '0')}
          </span>
        </div>
        <span className="text-text-muted text-xs mt-2 uppercase tracking-widest" data-id="element-81">
          seg
        </span>
      </div>
    </div>;
}